module.exports = __webpack_public_path__ + "img/pp_service1.7b798f01.png";